import { getCurrentReadingValue as e } from "./getCurrentReadingValue.js";
const r = (r2, t, n) => {
  if (!n) return false;
  const o = t || 6, i = r2.slice(0, o).filter((e2) => "" !== e2).length, l = parseFloat(e(r2, t) || "0");
  return i >= 1 && l < n;
};
export {
  r as isReadingLowerThanPrevious
};
//# sourceMappingURL=isReadingLowerThanPrevious.js.map
